export default {"src":"/_next/static/media/mail-icon.0c4e90f6.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};